import { removerComponenteReact, renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { DadosNotaFiscal } from "app/types/pesquisa-orcamento/consultas/NotasFiscais";
import { Dict } from "app/utils/Dict";
import React from "react";
import { MenuSubConsultasNotaFiscal } from "./MenuSubConsultasNotaFiscal";
import { NotaFiscalItensContainer } from "../notas-fiscais/sub-consultas/Itens/NotaFiscalItensContainer";
import { NotaFiscalFinanceiroContainer } from "../notas-fiscais/sub-consultas/financeiro/NotaFiscalFinanceiroContainer";
import { NotasFiscaisExpedicaoContainer } from "../notas-fiscais/sub-consultas/expedicao/NotasFiscaisExpedicaoContainer";
import { NotasFiscaisEntregaContainer } from "../notas-fiscais/sub-consultas/entrega/NotasFiscaisEntregaContainer";
import { NotaFiscalLotesContainer } from "../notas-fiscais/sub-consultas/lotes/NotaFiscalLotesContainer";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";


export type MenuSubConsultasNotaFiscalContainerProps = {
    notaFiscalSelecionada: Partial<DadosNotaFiscal>;
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    onSelecionadoMenu: () => void;
    onVoltar: () => void;
    passos: Dict<string, () => void>;
}

export type MenuSubConsultasNotaFiscal = {
    notaFiscalSelecionada: Partial<DadosNotaFiscal>;
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover?: () => boolean;
}


export const MenuSubConsultasNotaFiscalContainer = (props: MenuSubConsultasNotaFiscalContainerProps) => {

    const propsBase: MenuSubConsultasNotaFiscal = {
        notaFiscalSelecionada: props.notaFiscalSelecionada,
        orcamentoSelecionado: props.orcamentoSelecionado,
        onRemover: () => removerComponenteReact("pesquisar-pedidos-region"),
        onVoltar: () => props.onVoltar(),
        passos: props.passos,
    }

    const onRenderizarEntrega = () => {
        renderizarComponentReact(<NotasFiscaisEntregaContainer  {...propsBase} />, "pesquisar-pedidos-region", true)
    }

    const onRenderizarExpedicao = () => {
        renderizarComponentReact(<NotasFiscaisExpedicaoContainer  {...propsBase} />, "pesquisar-pedidos-region", true)
    }

    const onRenderizarFinanceiro = () => {
        renderizarComponentReact(<NotaFiscalFinanceiroContainer  {...propsBase} />, "pesquisar-pedidos-region", true)
    }

    const onRenderizarItens = () => {
        renderizarComponentReact(<NotaFiscalItensContainer  {...propsBase} />, "pesquisar-pedidos-region", true)
    }

    const onRenderizarLotes = () => {
        renderizarComponentReact(<NotaFiscalLotesContainer  {...propsBase} />, "pesquisar-pedidos-region", true)
    }


    return (
        <>

            <MenuSubConsultasNotaFiscal
                onRenderizarEntrega={onRenderizarEntrega}
                onRenderizarExpedicao={onRenderizarExpedicao}
                onRenderizarFinanceiro={onRenderizarFinanceiro}
                onRenderizarItens={onRenderizarItens}
                onRenderizarLotes={onRenderizarLotes}
                onSelecionadoMenu={props.onSelecionadoMenu}
            />

        </>
    )
}